import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./CardStar.module.scss";
import {iconImages} from "../../../config/config";

export interface ICardStarProps {
  isAwarded: boolean;
}

export const CardStar: VoidFunctionComponent<ICardStarProps> = ({isAwarded}) => {
  return (
    <img 
      className={s.star} 
      src={isAwarded ? iconImages.starWon : iconImages.starLostForCard} 
      alt={"Star"}
      width={16} 
      height={16} 
    />
  );
}

